import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import Loader from '../../components/main/Loader';
import { useSaveGlobalAppointmentsMutation } from '../../store/services/CalendarHoursService';
import { useGetSediVisibiliQuery } from '../../store/services/CalendarHoursDaysService';
import CityFormFields from './CityFormFields';
import { AppointmentLimitsForm } from './limits-form.model';
import { toast } from 'react-toastify';

export default function AppointmentLimits({ globalAppointments }: any) {

    const form = useForm<AppointmentLimitsForm>({
        defaultValues: globalAppointments,
        shouldUnregister: false
    });

    const { reset, handleSubmit } = form;

    const [saveGlobalAppointments, { isLoading }] = useSaveGlobalAppointmentsMutation();
    const { data: sediVisibiliData, isLoading: sediLoading } = useGetSediVisibiliQuery('');

    useEffect(() => {
        if (globalAppointments) {
            reset(globalAppointments);
        }
    }, [globalAppointments, reset]);

    const onSubmit = (data: AppointmentLimitsForm) => {
        const result = saveGlobalAppointments(data);
        if ('error' in result) {
            toast.error('Non è stato possibile aggiornare in n.appuntamenti')
        } else {
            toast.success('Numero appuntamenti globale per singola sede aggiornato');
        }
    }

    const cities = useMemo(() => {
        if (!globalAppointments) return [];
        return Object.keys(globalAppointments).filter(city => sediVisibiliData?.result?.[city] === true);
    }, [globalAppointments, sediVisibiliData]);

    return (
        <div className="bg-white shadow-lg rounded-lg p-6">
            {(isLoading || sediLoading) && <Loader />}
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {cities.map(city => (
                        <CityFormFields
                            key={city}
                            form={form}
                            city={city}
                        />
                    ))}
                </div>

                <div className="flex justify-end mt-6">
                    <button
                        disabled={isLoading || sediLoading}
                        className="h-10 bg-[#064e3b] text-white px-6 rounded-lg text-md"
                    >
                        Salva
                    </button>
                </div>
            </form>
        </div>
    );
}
